import { useLocation } from "react-router-dom";
import { Construction } from "lucide-react";

import { Card, CardBody } from "@/components/Card";
import { PageHeader } from "@/layout/PageHeader";
import { Page } from "@/layout/Page";
import { NAV_ITEMS } from "@/layout/navigation";

/**
 * A module that is planned but not built.
 *
 * Says so plainly instead of showing an empty table that looks broken, or fake
 * numbers that look real.
 */
export function ComingSoonPage() {
  const { pathname } = useLocation();
  const item = NAV_ITEMS.find((entry) => pathname.startsWith(entry.to));

  return (
    <Page width="reading">
      <PageHeader title={item?.label ?? "Module à venir"} />
      <Card>
        <CardBody className="flex flex-col items-center gap-3 py-12 text-center">
          <span className="rounded-full bg-surface-raised p-3 text-ink-subtle">
            <Construction className="size-6" aria-hidden />
          </span>
          <p className="text-sm font-medium text-ink">Ce module n'est pas encore construit</p>
          <p className="max-w-md text-[13px] text-ink-subtle">
            {item?.comingSoon
              ? `Prévu pour la ${item.comingSoon.toLowerCase()}.`
              : "Il arrivera dans une prochaine phase."}{" "}
            HD-Vault préfère le dire plutôt que d'afficher un écran vide ou des chiffres inventés.
          </p>
        </CardBody>
      </Card>
    </Page>
  );
}
